module.exports = __webpack_public_path__ + "static/media/privacy_icon.a1b78f2a.svg";